import { endOfDay, subDays, intervalToDuration, format } from 'date-fns';
import { getTimezoneOffset, toDate } from 'date-fns-tz';

export { default as endOfDay } from 'date-fns/endOfDay';
export { default as endOfMonth } from 'date-fns/endOfMonth';
export { default as startOfDay } from 'date-fns/startOfDay';
export { default as startOfMonth } from 'date-fns/startOfMonth';
export { default as differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
export { default as differenceInSeconds } from 'date-fns/differenceInSeconds';
export { default as intervalToDuration } from 'date-fns/intervalToDuration';
export { subDays };
export { default as subMonths } from 'date-fns/subMonths';
export { default as parseISO } from 'date-fns/parseISO';
export { format, utcToZonedTime, formatInTimeZone } from 'date-fns-tz';

export interface TimeComponents {
  timeDifference: number;
  formatted: string;
}

export function calcCountdownContent(endDay: Date): TimeComponents {
  const dDay = endDay.valueOf();

  const milliSecondsInASecond = 1000;
  const hoursInADay = 24;
  const minutesInAnHour = 60;
  const secondsInAMinute = 60;

  const timeDifference = dDay - Date.now();

  if (timeDifference <= 0) {
    return {
      timeDifference,
      formatted: '00h : 00m : 00s',
    };
  }

  const daysToDay = Math.floor(
    timeDifference /
      (milliSecondsInASecond *
        minutesInAnHour *
        secondsInAMinute *
        hoursInADay),
  );

  const hoursToDay = Math.floor(
    (timeDifference /
      (milliSecondsInASecond * minutesInAnHour * secondsInAMinute)) %
      hoursInADay,
  );

  const minutesToDay = Math.floor(
    (timeDifference / (milliSecondsInASecond * minutesInAnHour)) %
      secondsInAMinute,
  );

  const secondsToDay =
    Math.floor(timeDifference / milliSecondsInASecond) % secondsInAMinute;

  const formatted = `${daysToDay >= 10 ? '' : '0'}${daysToDay}d : ${
    hoursToDay >= 10 ? '' : '0'
  }${hoursToDay}h : ${minutesToDay >= 10 ? '' : '0'}${minutesToDay}m : ${
    secondsToDay >= 10 ? '' : '0'
  }${secondsToDay}s`;
  return {
    formatted,
    timeDifference,
  };
}

export function getTimezoneOffsetStr(timezone: string): string {
  // TODO: get reference to the date-fns-tz package
  const result = getTimezoneOffset(timezone); // => 7200000 (2 * 60 * 60 * 1000)
  return `UTC ${result / 3600000}`;
}

export function userTimeZoneToUTC(
  date: Date,
  end: boolean,
  options: {
    localOffset: string;
    timezone: string;
  },
): Date {
  return toDate(end ? endOfDay(date) : date, {
    timeZone: options.timezone,
  });
}

export function formatDate(param: Date | string): string {
  let date = '';
  if (typeof param === 'string') {
    date = param.slice(0, 10); // Avoid timezone offset
  } else {
    date = param.toISOString().slice(0, 10); // Avoid timezone offset
  }

  const dateParts = date.split('-'); // split the date string into year, month, and day components
  const year = dateParts[0]; // extract the year component
  const month = dateParts[1]; // extract the month component
  const day = dateParts[2]; // extract the day component
  return `${month}/${day}/${year}`; // return the formatted date string
}
export function getInterval(props: { start: Date; end: Date }) {
  const interval = intervalToDuration({
    start: props.start,
    end: props.end,
  });
  const years = interval.years ? `${interval.years} years` : '';
  const months = interval.months ? `${interval.months} months` : '';
  const days = interval.days ? `${interval.days} days` : '';
  const hours = interval.hours ? `${interval.hours} hours` : '';
  const minutes = interval.minutes ? `${interval.minutes} minutes` : '';
  const seconds = interval.seconds ? `${interval.seconds} seconds` : '';

  if (interval.years && interval.years > 0) {
    return years;
  }
  if (interval.months && interval.months > 0) {
    return months;
  }
  if (interval.days && interval.days > 0) {
    return days;
  }
  if (interval.hours && interval.hours > 0) {
    return hours;
  }
  if (interval.minutes && interval.minutes > 0) {
    return minutes;
  }
  if (interval.seconds && interval.seconds > 0) {
    return seconds;
  }
  return `Just now`;
}

export function fromStringToDate(string: string | Date, options?: { timeZone: string; localOffset: string }): Date {
  return toDate(string, {
    ...options
  });
}

export function queryParamsToDate(
  date: string,
  options: { localOffset: string; timezone: string },
): Date {
  return toDate(date, {
    timeZone: options.timezone,
  });
}

export function dateToQueryParams(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}
